import HttpService from './httpService';

export type DeliveryRuleField = 'pincode' | 'city' | 'district' | 'state';

export interface DeliveryChargeRule {
  _id: string;
  order: number;
  name: string;
  field: DeliveryRuleField;
  values: string[];
  charge: number;
  freeThreshold: number;
  isActive: boolean;
}

export interface DeliveryChargeConfig {
  defaultCharge: number;
  defaultFreeThreshold: number;
}

export interface CreateRulePayload {
  name: string;
  field: DeliveryRuleField;
  values: string[];
  charge: number;
  freeThreshold: number;
  order: number;
}

class DeliveryChargesService {
  private base = '/delivery-charges';

  // Config
  getConfig(): Promise<DeliveryChargeConfig> {
    return HttpService.get<any>(`${this.base}/config`).then((r: any) => r.data ?? r);
  }

  updateConfig(payload: DeliveryChargeConfig): Promise<void> {
    return HttpService.patch(`${this.base}/config`, payload);
  }

  // Rules
  getRules(): Promise<DeliveryChargeRule[]> {
    return HttpService.get<any>(`${this.base}/rules`).then((r: any) => r.data ?? r);
  }

  createRule(payload: CreateRulePayload): Promise<void> {
    return HttpService.post(`${this.base}/rules`, payload);
  }

  updateRule(id: string, payload: Partial<CreateRulePayload> & { isActive?: boolean }): Promise<void> {
    return HttpService.patch(`${this.base}/rules/${id}`, payload);
  }

  deleteRule(id: string): Promise<void> {
    return HttpService.delete(`${this.base}/rules/${id}`);
  }

  reorderRules(updates: { id: string; order: number }[]): Promise<void> {
    return HttpService.patch(`${this.base}/rules/reorder`, { updates });
  }

  searchValues(field: DeliveryRuleField, q: string): Promise<{ values: any[] }> {
    return HttpService.get<any>(`${this.base}/values/search?field=${field}&q=${encodeURIComponent(q)}`)
      .then((r: any) => r.data ?? r);
  }
}

export const deliveryChargesService = new DeliveryChargesService();
